/**
 * Get CSRF token from spring boot on app initialization
 * @param httpClient
 */
import {Observable, tap} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

export type SupportedLocale = {
    languageCode: string;
    supported: boolean;
}

export const getSupportedLocales = function (translate: TranslateService, http: HttpClient): () => Observable<any> {
    return ()=> http.get<Array<SupportedLocale>>('/api/i18n/locale')
        .pipe(
            map((locales)=>locales.map((locale: any) => locale.languageCode)),
            tap( locales => translate.addLangs(locales) )
        )

}